import React from 'react';
import P from '@hero/ui-kit/typography/P';

import { conditionText, patientConditions } from '../conditions';
import * as Style from '../style.module.scss';
import { CareRow } from '../types';

const PatientConditions: React.FC<{ rows: CareRow[] }> = ({ rows }) => {
    const { records, message } = patientConditions(rows);

    return (
        <details className={Style.patientDetails}>
            <summary>Conditions</summary>
            {records.length ? (
                <ul>
                    {records.map((record) => (
                        <li key={record.key}>{conditionText(record)}</li>
                    ))}
                </ul>
            ) : null}
            {message ? <P size="small">{message}</P> : null}
        </details>
    );
};

export default PatientConditions;
